import { accordion } from '@rynpsc/accordion';

export function accordionFunc() {
	let instance = accordion('accordion', {
		multiselect: true,
	});

	if (instance) {
		instance.init();
	}
}
